module.exports = __webpack_public_path__ + "assets/img/activity_recharge.39d0c2f2.png";